import axios from '../utils/axios';

const telegramUserService = {
    // Получить всех пользователей
    async getAllUsers() {
        const response = await axios.get('/telegram/bots/users');
        return response.data;
    },

    // Получить всех пользователей бота
    async getUsersByBot(botId, params = {}) {
        const response = await axios.get(`/telegram-bots/${botId}/users`, { params });
        return response.data;
    },

    // Получить статистику пользователей бота
    async getBotStats(botId) {
        const response = await axios.get(`/telegram/bots/${botId}/users/stats`);
        return response.data;
    },

    // Получить конкретного пользователя
    async getUser(botId, userId) {
        const response = await axios.get(`/telegram/bots/${botId}/users/${userId}`);
        return response.data;
    },

    // Получить заказы пользователя и статистику
    async getUserOrders(userId, params = {}) {
        const query = new URLSearchParams(params).toString();
        const response = await axios.get(`/telegram/users/${userId}/orders${query ? `?${query}` : ''}`);
        return response.data;
    },

    // Заблокировать/разблокировать пользователя
    async toggleBlock(userId) {
        const response = await axios.post(`/telegram/users/${userId}/toggle-block`);
        return response.data;
    },

    // Обновить баланс пользователя
    async updateBalance(userId, amount) {
        const response = await axios.post(`/telegram/users/${userId}/balance`, { amount });
        return response.data;
    },

    // Получить заметку пользователя
    async getUserNote(userId) {
        const response = await axios.get(`/telegram/users/${userId}/note`);
        return response.data;
    },

    // Обновить заметку пользователя
    async updateUserNote(userId, note) {
        const response = await axios.put(`/telegram/users/${userId}/note`, { note });
        return response.data;
    }
};

export default telegramUserService;
